module.exports = __webpack_public_path__ + "img/padlock.85eb927b.svg";